module.exports = __webpack_public_path__ + "img/copper-ore.05484482.png";